import { getPersistentId } from '../activityTracker/helpers';
import { useCurrentUser } from '../user/useCurrentUser';

const BRANCH_TOKEN = process.env.NEXT_PUBLIC_BRANCH_TOKEN!;

export function useBranch() {
  const [, user] = useCurrentUser();
  function initBranch() {
    return import('branch-sdk').then(() => {
      const options = {
        no_journeys: false,
      };
      window.branch.init(BRANCH_TOKEN, options);
      return window.branch;
    });
  }

  async function getBranch() {
    const persistentId = await getPersistentId();

    if (typeof window.branch !== 'undefined') {
      if (!user) {
        window.branch.setIdentity(persistentId ?? '');
      }
      return window.branch;
    }
    return await initBranch();
  }

  return { getBranch };
}
